import '../navigation/Navbar.scss';
import profile from '../../images/Ellipse_170.png'
import option from '../../images/option.png';
import Profile from '../../images/avatar.png';
import Logout from '../../images/logout.png';
import Earning from '../../images/earnings.png';
import PaymentProofImg from '../../images/job-icon.png';
import NavOptions from './NavOptions';
import { Link } from 'react-router-dom';
import NavItem from './NavItem';
import HamburgerMenu from './NavSideBar';
import { ContentPaste, Home, Info, Task, Work, WorkOutline } from '@mui/icons-material';
import { Avatar, Menu, IconButton, Tooltip, MenuItem, Typography, Snackbar, Alert } from '@mui/material';
import { useState } from 'react';
import toList, { isAuthenticated, logout } from '../utils/ComponentUtil';
import BrowseJobsAPI from '../Apis/BrowseJobsApi';
import TalentsAPI from '../Apis/TalentsAPI';

function Navbar({ selected = '', showError = false }) {
    const pathname = window.location.pathname;
    const isLoggedIn = isAuthenticated();
    const browseJobs = Object.values(BrowseJobsAPI.getJobs()).map(j => { return { ...j, img: option }; });
    const navOptions = {
        "home": {
            "name": "Home",
            "icon": <Home />,
            "to": "/"
        },
        "daily_jobs": {
            "name": "Daily Jobs",
            "icon": <Task />,
            "options":
                [
                    {
                        "img": option,
                        "name": "Proof Reading Jobs",
                        "to": "/internships/custom/proof-reading"
                    },
                    {
                        "img": option,
                        "name": "New Proof Reading Jobs",
                        "to": "/internships/custom/new-proof-reading"
                    },
                    {
                        "img": option,
                        "name": "Review Writing Jobs",
                        "to": "/internships/custom/review-writing"
                    },
                    {
                        "img": option,
                        "name": "Copy Paste Jobs",
                        "to": "/internships/custom/copy-paste"
                    }
                ]
        },
        "browse_jobs": {
            "name": "Browse Jobs",
            "icon": <Task />,
            "options": browseJobs
        },
        "internships": {
            "name": "Internships",
            "icon": <WorkOutline />,
            "to": "/internships"
        },
        "post_talent": {
            "name": "Post Your Talent",
            "icon": <ContentPaste />,
            "options": TalentsAPI.talentTypes
        },
        "post_project": {
            "name": "Post Your Project",
            "icon": <Work />,
            "options": TalentsAPI.talentTypes.map(t => { return { ...t, to: t.to.replace('/post-talent/', '/post-project/') }; })
        },
        "hire_talent": {
            "name": "Hire A Talent",
            "icon": <Work />,
            "to": "/hire-talent"
        },
        "others": {
            "name": "More",
            "icon": <Info />,
            "options": [
                {
                    "img": option,
                    "name": "About Us",
                    "to": "/about-us"
                },
                {
                    "img": option,
                    "name": "Blogs",
                    "to": "/blogs"
                },
                {
                    "img": option,
                    "name": "Contact Us",
                    "to": "/#contact"
                },
                {
                    "img": option,
                    "name": "FAQ’s",
                    "to": "/faq"
                }
            ]
        }
    }
    const mobileNavOptions = {
        "home": {
            "name": "Home",
            "to": "/"
        },
        "internships": {
            "name": "Work From Home",
            "tip": "Internships",
            'bottomTip': 'With Guaranteed Payments',
            'to': '/internships' 
        },
        "freelance_jobs": {
            "name": "Find Work",
            "options": [
                {
                    'name': 'Post Your Talent',
                    'subTitle': 'Post your talent and get hired',
                    'to': '/post-talent/proof-reading' 
                },
                {
                    'name': 'Find a project',
                    'subTitle': 'Find a perfect job & work as you wish.',
                    'to': '/find-project' 
                },
                {
                    'name': 'Job Board',
                    'subTitle': 'Find all available jobs',
                    'to': '/jobs'
                }
            ]
        },
        "freelance_talents": {
            "name": "Find Talents",
            "options": [
                {
                    'name': 'Hire a Talent',
                    'subTitle': 'Choose your perfect talent for your work.',
                    'to': '/hire-talent' 
                },
                {
                    'name': 'Post a Project',
                    'subTitle': 'Post your project and hire professionals',
                    'to': '/post-project/proof-reading'
                }
            ]
        },
        "company_jobs": {
            "name": "For Companies",
            "options": [
                {
                    'name': 'Post a Job',
                    'subTitle': 'Post a job and hire professionals',
                    'to': '/post-job' 
                },
                {
                    'name': 'Post an Internship',
                    'subTitle': 'Post an Internship and hire professionals',
                    'to': '/post-internship'
                }
            ]
        },
        "help": {
            "name": "Help",
            "to": '/',
            "options": [
                {
                    "img": option,
                    "name": "About Us",
                    "to": "/about-us"
                },
                {
                    "img": option,
                    "name": "Blogs",
                    "to": "/blogs"
                },
                {
                    "img": option,
                    "name": "Contact Us",
                    "to": "/#contact"
                },
                {
                    "img": option,
                    "name": "FAQ’s",
                    "to": "/faq"
                }
            ]
        }
    }
    const [anchorElUser, setAnchorElUser] = useState();
    const settings = [
        {
            name: 'Profile',
            to: '/profile',
            img: Profile,
        },
        {
            name: 'Payment Proof',
            to: '/payment-proof',
            img: PaymentProofImg,
        },
        {
            name: 'Earning Summary',
            to: '/earnings',
            img: Earning
        },
        {
            name: 'Logout',
            to: '/logout',
            img: Logout,
            onClick: (e) => logout(e)
        }];
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    return (
        <div className='navbar-wrp wrapper'>
            <HamburgerMenu options={mobileNavOptions}></HamburgerMenu>
            <div className="logo-wrp">
                <Link reloadDocument={true} to={isLoggedIn ? '/home' : '/' }><div>Jobf<span>i</span>.in</div></Link>
            </div>
            <div className="options-wrp">
            {toList(Object.values(mobileNavOptions), undefined, (item, i) => 
                <NavItem name={item?.name} to={item?.to} selected={selected} key={i} child={<NavOptions options={item.options}></NavOptions>}></NavItem>
            )}
            </div>
            <div className="login-wrp">
                {
                    isAuthenticated() ?
                        <>
                            <Tooltip title="Open settings">
                                <IconButton onClick={handleOpenUserMenu}>
                                    <Avatar alt="Remy Sharp" src={profile} />
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                                className='profile-settings'
                            >
                                {settings.map((setting, i) => (
                                    <Link reloadDocument={true} to={setting?.to} key={i}>
                                        <MenuItem key={setting?.name} onClick={handleCloseUserMenu}>
                                            <img className='icon' src={setting?.img} alt='icon'/>
                                            <Typography textAlign="center" onClick={setting?.onClick}>
                                                {setting?.name}</Typography>
                                        </MenuItem>
                                    </Link>
                                ))}
                            </Menu>
                        </> :
                        <>
                            {pathname !== '/login' && <div className="login-container"><Link reloadDocument={true} to='/login'>Login</Link></div>}
                            {pathname !== '/signup' && <div className="signup-container">
                                <div className="signup-btn"><Link reloadDocument={true} to='/signup'>Sign Up</Link></div>
                            </div>}</>
                }
            </div>
            <Snackbar autoHideDuration={600} >
                <Alert severity="success" sx={{ width: '100%' }}>
                    This is a success message!
                </Alert>
            </Snackbar>
        </div>
    );
}

export default Navbar;